import React, { useEffect, useState } from 'react';
import logoo from '../../Images/logoo.png';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { CiSearch } from 'react-icons/ci'
import { AiOutlineShopping } from 'react-icons/ai'
import { RiArrowDropDownLine } from 'react-icons/ri';
import { GetCartItems } from '../Data';
import Util from '../../Classes/Utils';
import { Global } from '../Variables/Global';
import Cookies from 'js-cookie';

const HeaderAR = (props) => {
  const [text, setText] = useState("");
  const [cartItems, setCartItems] = useState([]);
  const [isLogged, setIsLogged] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const navigate = useNavigate();
  const token = Cookies.get("CustomerToken");

  const handleSubmit = () => {
    navigate("/");
  }
  const handleSearch = () => {
    if (text) {
      navigate(`/AR/Product/${text}`);
    } else {
      navigate("/AR/shop");
    }
  }

  const GetWishListItemsForHeader = () => {
    var groupId;
    if (Cookies.get("WishList") !== undefined) { groupId = 4 } else { groupId = 3 }

    const getItem = (Cookies.get('Cart') !== undefined);
    if (getItem) {
      var CartId =Cookies.get("Cart");
      GetCartItems(CartId, groupId,token).then((Result) => {
        setCartCount(Result.Count);
        setCartItems(Result.CartItems);

      });
    }
  }

  const getTotal = () => {
    var Sumtotal = 0;
    const arr = Array.from(cartItems);
    arr.forEach(element => {
      if (element.SalePrice === 0) {
        Sumtotal += element.RegularPrice * element.Quantity;
      } else {
        Sumtotal += element.SalePrice * element.Quantity
      }
    })
    return Sumtotal;

  }

  const HandleLogout = () => {
    Cookies.remove("CustomerToken",{
      expires: new Date(),
      path: '/'
    });
    Cookies.remove("User");
    Cookies.remove("WishList");
    Cookies.remove("Cart");
    Cookies.remove("Subscribe");
    Cookies.remove("Number");
    setIsLogged(false);
    navigate('/AR/Authentication');
}


  useEffect(() => {
    if (Cookies.get("CustomerToken") === undefined) {
      setIsLogged(false);
    } else {
      setIsLogged(true);
    }
    GetWishListItemsForHeader();
  }, [isLogged])

  return (
    <>
      <header>
        {/* <!--=======  header top  =======--> */}

        <div className="header-top pt-10 pb-10 pt-lg-10 pb-lg-10 pt-md-10 pb-md-10">
          <div className="container">
            <div className="row pt-2">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center text-sm-start">
                {/* <!-- currncy language dropdown --> */}
                <div className="lang-currency-dropdown">
                  <div>
                    <ul>
                      <li><a className="whiteItem RemUnderlineHF en">عربي <RiArrowDropDownLine /></a>
                        {/* <i className="fa fa-chevron-down"></i> */}
                        <ul>
                          <li>
                            <a className='RemUnderlineHF ar' onClick={handleSubmit}>English</a>
                          </li>

                        </ul>
                      </li>
                      <li><a className="whiteItem RemUnderlineHF">AED <i className="fa "></i></a>
                        {/* <!-- <ul>
                          <li><a href="#">AED</a></li>
                        </ul> --> */}
                      </li>
                    </ul>
                  </div>
                </div>
                {/* <!-- end of currncy language dropdown --> */}
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12  text-center text-sm-end">
                {/* <!-- header top menu --> */}
                <div className="header-top-menu">
                  <ul>
                    <li className="directionRtl"><a className='RemUnderlineHF' href="/AR/Account">حسابي</a></li>
                    <li className="directionRtl"><a className='RemUnderlineHF' href="/AR/Wishlist">المفضلة </a></li>
                    {/* <li className="directionRtl"><a className='RemUnderlineHF' href="/AR/Checkout">الدفع</a></li> */}
                  </ul>
                </div>
                {/* <!-- end of header top menu --> */}
              </div>
            </div>
          </div>
        </div>

        {/* <!--=======  End of header top  =======-->

        <!--=======  header bottom  =======--> */}

        <div className="header-bottom header-bottom-one header-sticky">
          <div className="container">
            <div className="row">
              <div className="col-md-3 col-sm-12 col-xs-12 text-lg-start text-md-center text-sm-center">
                {/* <!-- logo --> */}
                <div className="logo mt-15 mb-15">
                  <a href="/AR">
                    <img width="200" height="200" src={logoo} className="img-logo" alt="" />
                  </a>
                </div>
                {/* <!-- end of logo --> */}
              </div>
              <div className="col-md-9 col-sm-12 col-xs-12">
                <div
                  className="menubar-top d-flex justify-content-between align-items-center flex-sm-wrap flex-md-wrap flex-lg-nowrap mt-sm-15">
                  {/* <!-- header phone number --> */}


                  {/* <!-- <div className="header-contact d-flex">
                    <div className="phone-icon">
                      <img width="40" height="35" src="assets/images/icon-phone.webp" className="img-fluid" alt="">
                    </div>
                    <div className="phone-number">
                      Phone: <span className="number">1-888-123-456-89</span>
                    </div>



                  </div> --> */}
                  {/* <!-- end of header phone number --> */}
                  {/* <!-- search bar --> */}
                  <div className="header-advance-search">
                    <form onSubmit={handleSearch}>
                      <input className="directionRtl" type="text" placeholder="إبحث عن منتج" onChange={(e) => setText(e.target.value)} />
                      <button type='submit'>
                        <CiSearch />
                      </button>
                    </form>
                  </div>
                  {/* <!-- end of search bar --> */}
                  {/* <!-- shopping cart --> */}
                  <div className="shopping-cart" id="shopping-cart">
                    <a href="/AR/Cart">
                      <div className="cart-icon d-inline-block">
                        {/* <span className="icon_bag_alt"></span> */}
                        <span><AiOutlineShopping /></span>
                      </div>
                      <div className="cart-info d-inline-block">
                        <p className="directionRtl">سلة التسوق
                          {
                            isLogged && (
                              <span>
                                أغراض {cartCount} - AED{getTotal()}
                              </span>
                            )
                          }
                        </p>
                      </div>
                    </a>
                    {/* <!-- end of shopping cart --> */}

                    {/* <!-- cart floating box --> */}
                    <div className="cart-floating-box" id="cart-floating-box" style={{ direction: 'rtl' }}>
                      {
                        cartItems.length > 0 ? (
                          cartItems.slice(0, 2).map((item, index) => {
                            return (
                              <div key={index} className="cart-items">
                                <div className="cart-float-single-item d-flex">
                                  {/* <span className="remove-item"><a href="#"><i className="fa fa-times"></i></a></span> */}
                                  <div className="cart-float-single-item-image">
                                    <a href={"/AR/DetailedProduct/" + item.ProductName.replace(/ /g, "-") + "/" + item.ProductId + "/" + item.ProductVariationId}><img width="350" height="350" src={Global.PHOTO_URL + item.Image} className="img-fluid"
                                      alt="" /></a>
                                  </div>
                                  <div className="cart-float-single-item-desc" style={{ marginRight: '10px' }}>
                                    <p className="product-title"> <a href={"/AR/DetailedProduct/" + item.ProductName.replace(/ /g, "-") + "/" + item.ProductId + "/" + item.ProductVariationId}>{item.ProductNameAR}</a></p>
                                    <p className="price"><span className="count">{item.Quantity}x</span>
                                      {
                                        item.SalePrice === 0 ? (
                                          <>
                                            <span className="discounted-price RemUnderline">AED{item.RegularPrice}</span>

                                          </>
                                        ) : (
                                          <>
                                            <span className="discounted-price RemUnderline">AED{item.SalePrice}</span>
                                            <span className="main-price RemUnderline">AED{item.RegularPrice}</span>
                                          </>
                                        )
                                      }
                                    </p>
                                  </div>
                                </div>

                              </div>
                            )
                          })
                        ) : (
                          <h1 style={{ fontSize: '20px' }}>لا منتجات في عربة التسوق</h1>
                        )
                      }
                      <div className="cart-calculation" style={{ direction: 'rtl' }}>
                        <div className="calculation-details" style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <p className="total"> المجموع</p>
                          <span>AED {getTotal()}</span>
                        </div>
                        <div className="floating-cart-btn text-center">
                          {/* <a href="/Checkout">Checkout</a> */}
                          <a href="/AR/cart">عربة التسوق</a>
                        </div>
                      </div>
                    </div>
                    {/* <!-- end of cart floating box --> */}
                  </div>
                </div>

                {/* <!-- navigation section --> */}
                <div className="main-menu">
                  <nav>
                    <ul className="directionRtl">
                      {/* <!--  active menu-item-has-children --> */}
                      {/* <!-- <li className="active"><a href="#">HOME</a>
                        <ul className="sub-menu">
                          <li><a href="index.html">Home Shop 1</a></li>
                          <li><a href="index-2.html">Home Shop 2</a></li>
                          <li><a href="index-3.html">Home Shop 3</a></li>
                          <li><a href="index-4.html">Home Shop 4</a></li>
                          <li><a href="index-5.html">Home Shop 5</a></li>
                          <li><a href="index-6.html">Home Shop 6</a></li>
                        </ul>
                      </li> --> */}
                      {/* <!-- menu-item-has-children --> */}
                      <li className="directionRtl"><a className='RemUnderlineHF' href="/AR/Shop">المتجر</a>
                        {/* <!-- <ul className="sub-menu">
                          <li className="menu-item-has-children"><a href="shop-4-column.html">shop grid</a>
                            <ul className="sub-menu">
                              <li><a href="shop-3-column.html">shop 3 column</a></li>
                              <li><a href="shop-4-column.html">shop 4 column</a></li>
                              <li><a href="shop-left-sidebar.html">shop left sidebar</a></li>
                              <li><a href="shop-right-sidebar.html">shop right sidebar</a></li>
                            </ul> --> 
                          </li>*/}
                        {/* <!-- <li className="menu-item-has-children"><a href="shop-list.html">shop List</a>
                            <ul className="sub-menu">
                              <li><a href="shop-list.html">shop List</a></li>
                              <li><a href="shop-list-left-sidebar.html">shop List Left Sidebar</a></li>
                              <li><a href="shop-list-right-sidebar.html">shop List Right Sidebar</a></li>
                            </ul>
                          </li> --> */}

                        {/* <!-- <li className="menu"><a href="single-product.html">Cart</a> -->
                            <!-- <li className="menu-item-has-children"><a href="single-product.html">Single Product</a>
                              <ul className="sub-menu">
                                <li><a href="single-product.html">Single Product</a></li>
                                <li><a href="single-product-variable.html">Single Product variable</a></li>
                                <li><a href="single-product-affiliate.html">Single Product affiliate</a></li>
                                <li><a href="single-product-group.html">Single Product group</a></li>
                                <li><a href="single-product-tabstyle-2.html">Tab Style 2</a></li>
                                <li><a href="single-product-tabstyle-3.html">Tab Style 3</a></li>
                                <li><a href="single-product-gallery-left.html">Gallery Left</a></li>
                                <li><a href="single-product-gallery-right.html">Gallery Right</a></li>
                                <li><a href="single-product-sticky-left.html">Sticky Left</a></li>
                                <li><a href="single-product-sticky-right.html">Sticky Right</a></li>
                                <li><a href="single-product-slider-box.html">Slider Box</a></li>

                              </ul> --> */}
                      </li>



                      {/* <!-- menu-item-has-children --> */}
                      {
                        isLogged ? (
                          <li className="menu-item-has-children"><a className='RemUnderlineHF' href="/AR/Account"><RiArrowDropDownLine />حسابي</a>
                            <ul className="sub-menu">
                              <li><a className='RemUnderlineHF' href="/AR/Account">الطلبات</a></li>
                              <li><a className='RemUnderlineHF' onClick={HandleLogout} >تسجيل خروج</a></li>
                            </ul>
                          </li>
                        ) : (
                          <li className="menu-item-has-children"><a className='RemUnderlineHF' href="/AR/Authentication"><RiArrowDropDownLine />تسجيل الدخول</a>
                            <ul className="sub-menu">
                              <li><a className='RemUnderlineHF' href="/AR/Authentication">حساب جديد</a></li>
                            </ul>
                          </li>
                        )
                      }







                      <li className="menu"><a className='RemUnderlineHF' href='/AR/Contact'>تواصل معنا</a></li>
                      {/* </ul>
                      </li> */}
                      {/* <!-- <li className="menu-item-has-children"><a href="#">PAGES</a>
                        <ul className="mega-menu three-column">
                          <li><a href="#">Column One</a>
                            <ul>
                              <li><a href="cart.html">Cart</a></li>
                              <li><a href="checkout.html">Checkout</a></li>
                              <li><a href="wishlist.html">Wishlist</a></li>

                            </ul>
                          </li>
                          <li><a href="#">Column Two</a>
                            <ul>
                              <li><a href="my-account.html">My Account</a></li>
                              <li><a href="login-register.html">Login Register</a></li>
                              <li><a href="faq.html">FAQ</a></li>
                            </ul>
                          </li>
                          <li><a href="#">Column Three</a>
                            <ul>
                              <li><a href="compare.html">Compare</a></li>
                              <li><a href="contact.html">Contact</a></li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li className="menu-item-has-children"><a href="#">BLOG</a>
                        <ul className="sub-menu">
                          <li><a href="blog-3-column.html">Blog 3 column</a></li>
                          <li><a href="blog-grid-left-sidebar.html">Blog Grid Left Sidebar</a></li>
                          <li><a href="blog-grid-right-sidebar.html">Blog Grid Right Sidebar</a></li>
                          <li><a href="blog-list-left-sidebar.html">Blog List Left Sidebar</a></li>
                          <li><a href="blog-list-right-sidebar.html">Blog List Right Sidebar</a></li>
                          <li><a href="blog-post-left-sidebar.html">Blog Post Left Sidebar</a></li>
                          <li><a href="blog-post-right-sidebar.html">Blog Post Right Sidebar</a></li>
                          <li><a href="blog-post-image-format.html">Blog Post Image Format</a></li>
                          <li><a href="blog-post-image-gallery.html">Blog Post Image Gallery Format</a></li>
                          <li><a href="blog-post-audio-format.html">Blog Post Audio Format</a></li>
                          <li><a href="blog-post-video-format.html">Blog Post Video Format</a></li>
                        </ul>
                      </li> --> */}
                      {/* <!-- <li><a href="contact.html">CONTACT</a></li> --> */}
                    </ul>
                  </nav>
                </div>
                {/* <!-- end of navigation section --> */}
              </div>
              <div className="col-12">
                {/* <!-- Mobile Menu --> */}
                <div className="mobile-menu d-block d-lg-none"></div>
              </div>
            </div>
          </div>
        </div>

        {/* <!--=======  End of header bottom  =======--> */}
      </header>
      {/* <!--=====  End of Header  ======--> */}
    </>


  )
}

export default HeaderAR